// 环境配置文件，区分各个环境
let origin = window.location.origin;
let host = window.location.host;
host = host.split(':')[0];
// const protocol = window.location.protocol;
const protocol = "https:";
let platform = 'devlop';
switch (host) {
  case 'localhost':
  case '127.0.0.1':
    platform = 'devlop';
    break;
  case '120.31.138.91':
  case '10.11.70.14':
  case 'test-agentfront.eflycloud.com':
  case 'test-agent150b9.eflycloud.com':
  case 'test-agent12cff.eflycloud.com':
  case 'test-agent13e37.eflycloud.com':
  case 'agent9d35.eflycloud.com':
  case 'agentbc16.eflycloud.com':
  case 'test-tpl.eflycloud.com':
    platform = 'test';
    break;
  case '121.201.125.130':
  case 'pre-agentfront.eflycloud.com':
  case 'agent17d90.eflycloud.com':
  case 'agent15db7.eflycloud.com':
  case 'agent117da.eflycloud.com':
  case 'agent167e7.eflycloud.com':
  case 'agent147ec.eflycloud.com':
  case 'agent102b1.eflycloud.com':
  case 'agent102b1.eflycloud.com':
  case 'agent129ca.eflycloud.com':
  case 'agentea54.eflycloud.com':
  case 'agent4913.eflycloud.com':
  case 'agent9e86.eflycloud.com':
  case 'agent665e.eflycloud.com':
  case 'agent953d.eflycloud.com':
  case 'agent6474.eflycloud.com':
  case 'agent17d90.agent.eflycloud.com':
  case 'agent15db7.agent.eflycloud.com':
  case 'agent117da.agent.eflycloud.com':
    platform = 'preonline';
    break;
  default:
    platform = 'online';
}

const envUrl: {
  [key: string]: {
    host: any;
    apiUrl: any;
    vncUrl: any;
    imgUrl?: string;
    gkUrl?: string;
    publicPath?: string;
    deployMode?: string; // 部署方式：domain域名部署 | ip主机IP+端口部署
    platform?: string;
  };
} = {
  devlop: {
    host: host,
    platform:platform,
    apiUrl: 'http://121.201.75.201:8000',
    vncUrl: 'http://120.31.138.91:30005/vncCore',
    deployMode: 'ip'
  },
  test: {
    host: host,
    platform:platform,
    apiUrl: protocol + '//test-agentafter.eflycloud.com',
    vncUrl: origin + '/vncCore',
    deployMode: 'domain'
  },
  preonline: {
      host: host, // pre用域名部署，host传部署机器ip
      platform:platform,
      apiUrl: protocol + '//pre-agentafter.eflycloud.com',
      vncUrl: origin + '/vncCore',
      deployMode: 'domain'
  },

  online: {
    host: host,
    platform:platform,
    apiUrl: protocol + '//agentafter.eflycloud.com',
    vncUrl: origin + '/vncCore',
    deployMode: 'domain'
  }
};

export const environment = envUrl[platform]
